import { windowWidth } from "src/styles/global";
import styled from "styled-components";

const Container = styled.div`
  height: 100%;
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Header = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  padding: 6px 15px 6px 15px;
`;

const HeaderTitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
`;

const HeaderFilters = styled.div`
  display: flex;

  > :first-child {
    max-width: 300px;
    width: 300px;

  }

  @media (max-width: ${windowWidth.mobile.large}) {
    width: 100%;

    > :first-child {
      max-width: 100%;
      width: 100%;
    }
  }
`;

const Board = styled.div`
  width: 100%;
  padding: 8px 15px;
  display: grid;
  grid-template-columns: 1fr;
  align-content: start;
  gap: 16px;
  overflow-y: scroll;
  padding-bottom: 102px;

  @media (min-width: ${windowWidth.tablet}) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: ${windowWidth.tablet}) {
    scrollbar-width: none;
  }
`;

const NoRecordsFound = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
  width: 100%;
  font-size: 14px;
  color: ${({ theme }) => theme.brand.muted};

  grid-column: 1 / -1;
`;

const SpeedDialButtonContainer = styled.div`
  &.no-permission {
    pointer-events: auto !important;
    cursor: not-allowed !important;

    div {
      background-color: ${({ theme }) => theme.brand.line};
      color: ${({ theme }) => theme.brand.muted};
      pointer-events: none!important;

      &:hover {
        background-color: ${({ theme }) => theme.brand.line};
        color: ${({ theme }) => theme.brand.muted};
      }
    }
  }
`;

export { Container, Header, HeaderTitle, HeaderFilters, Board, NoRecordsFound, SpeedDialButtonContainer };